module.exports = __webpack_public_path__ + "img/5F5F5F_BDBDBD_A4A4A4_9C9C9C-256px.b65993e6.png";